/**
 * Pedidos cujo pagamento esta página está conduzindo agora (do m-SiTef até o fim do onSucessPayment).
 * A recuperação ignora esses: o registro do app Android ainda não foi apagado porque o fluxo
 * normal não terminou (ex.: modal da NFC-e aberto), não porque o retorno se perdeu.
 * Some com a página: depois de um recarregamento, o que sobrou no app é de fato recuperação.
 */
const inFlight = new Set<string>();

export const markPaymentInFlight = (orderId: string) => inFlight.add(orderId.toLowerCase());

export const clearPaymentInFlight = (orderId: string) => inFlight.delete(orderId.toLowerCase());

export const isPaymentInFlight = (orderId: string) => inFlight.has(orderId.toLowerCase());
